import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatSnackBarModule,
  MatMenuModule,
  MatProgressBarModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatTabsModule,
  MatToolbarModule, MatRippleModule,
  MatPaginatorModule,
  MatNativeDateModule
} from '@angular/material';

import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';

import { FlexLayoutModule } from '@angular/flex-layout';

import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { SecureComponent } from './secure.component';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { SidebarComponent } from './../_shared/layout/sidebar/sidebar.component';
import { SecureRoutingModule } from './secure-routing.module';

import { HeaderComponent } from './../_shared/layout/header/header.component';
import { MenuComponent } from './../_shared/layout/menu/menu.component';

import { AccordionAnchorDirective } from './../_shared/layout/menu-accordion/accordionanchor.directive';
import { AccordionLinkDirective } from './../_shared/layout/menu-accordion/accordionlink.directive';
import { AccordionDirective } from './../_shared/layout/menu-accordion/accordion.directive';

// secure services here
// import { LookupService } from '../_services/admin/lookup.service';
import { DashboardService } from '../_services/admin/dashboard.service';
import { ContactsService } from '../_services/admin/contacts.service';
import { ProductsService } from '../_services/admin/products.service';
import { CategoryService } from '../_services/admin/category.service';
import { EnquiryService } from '../_services/admin/enquiry.service';
import { SubscriberService } from '../_services/admin/subscriber.service';
import { ProductimageService } from '../_services/admin/productimage.service';

import { ContactsComponent } from './home/contacts/contacts.component';
import { EnquiryComponent } from './home/enquiry/enquiry.component';
import { ChangePasswordComponent } from './home/change-password/change-password.component';
import { ProductMainComponent } from './home/product-main/product-main.component';
import { ProductsComponent } from './home/product-main/products/products.component';
import { CategoryComponent } from './home/product-main/category/category.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ProductcateditComponent } from './home/product-main/productcatedit/productcatedit.component';
import { AddProductComponent } from './home/product-main/add-product/add-product.component';
import { AddCategoryComponent } from './home/product-main/category/add-category/add-category.component';
import { EditproductComponent } from './home/product-main/editproduct/editproduct.component';
import { SubscribersComponent } from './home/subscribers/subscribers.component';
import { ProductImagesComponent } from './home/product-main/product-images/product-images.component';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
};
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './../assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    SecureComponent,
    HomeComponent,
    DashboardComponent,
    SidebarComponent,
    HeaderComponent,
    MenuComponent,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ContactsComponent,
    CategoryComponent,
    EnquiryComponent,
    ChangePasswordComponent,
    ProductMainComponent,
    ProductsComponent,
    ProductcateditComponent,
    AddProductComponent,
    AddCategoryComponent,
    EditproductComponent,
    SubscribersComponent,
    ProductImagesComponent
  ],
  entryComponents: [
    // pop up component here also define
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingBarRouterModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatIconModule,
    MatDialogModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatToolbarModule,
    MatTableModule,
    SecureRoutingModule,
    PerfectScrollbarModule,
    MatSnackBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    NgxDatatableModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    MatDatepickerModule,
    DashboardService,
    ContactsService,
    EnquiryService,
    SubscriberService,
    ProductimageService,
    CategoryService,
    ProductsService
  ]
})
export class SecureModule { }

